import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e5a0e68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pagination-container"
}

import { withDefaults } from 'vue';

interface Props {
  total: number;
  pageNo?: number;
  pageSizes?: number[];
  pageSize?: number;
  layout?: string;
  background?: boolean;
  autoScroll?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    total: {},
    pageNo: { default: 1 },
    pageSizes: { default: () => [10, 20, 30, 50] },
    pageSize: { default: 10 },
    layout: { default: 'total, sizes, prev, pager, next, jumper' },
    background: { type: Boolean, default: true },
    autoScroll: { type: Boolean, default: true }
  },
  emits: ['pagination', 'update:pageNo', 'update:pageSize'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleSizeChange = (val: number) => {
  emit('update:pageSize', val);
  emit('pagination', { pageNo: props.pageNo, pageSize: val });
};

const handleCurrentChange = (val: number) => {
  emit('update:pageNo', val);
  emit('pagination', { pageNo: val, pageSize: props.pageSize });
};

return (_ctx: any,_cache: any) => {
  const _component_e_pagination = _resolveComponent("e-pagination")!

  return (_ctx.total > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_e_pagination, {
          background: _ctx.background,
          effect: "cm",
          "current-page": _ctx.pageNo,
          "page-sizes": _ctx.pageSizes,
          "page-size": _ctx.pageSize,
          layout: _ctx.layout,
          total: _ctx.total,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["background", "current-page", "page-sizes", "page-size", "layout", "total"])
      ]))
    : _createCommentVNode("", true)
}
}

})